import useSWR from "swr";

import type { PromiseClient } from "@bufbuild/connect";
import type {
  GetEventSearchConditionsResponse,
  LegacyPortalSearchService,
} from "@spwn-portal/grpc";

type Input = {
  client: PromiseClient<typeof LegacyPortalSearchService>;
};
type Output = {
  genreConditions: GetEventSearchConditionsResponse["genre"] | null;
};
type UseGetGenreConditions = (input: Input) => Output;

export const useGetGenreConditions: UseGetGenreConditions = (input) => {
  const { client } = input;
  const fetcher = async () => client.getEventSearchConditions({});
  const { data } = useSWR("getEventSearchConditions", fetcher);
  const genreConditions = data?.genre ?? null;

  return { genreConditions };
};
